// extracted by mini-css-extract-plugin
export var boxItems = "_92-1";
export var boxItemsLg = "_92-2";
export var button = "_92-7";
export var buttonHoverless = "_92-9";
export var buttonLg = "_92-8";
export var filterGroupBox = "_92-0";
export var icon = "_92-3";
export var iconSecondary = "_92-6";
export var iconWrapper = "_92-4";
export var iconWrapperLg = "_92-5";
export var truncatedLabel = "_92-a";